import React from 'react'

import { EllipseIcon } from '@guiker/react-framework'

export const ActivityMarker: React.FC = () => {
  return <EllipseIcon size={6} color={30} />
}
